var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTshirt = function SvgTshirt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "t-shirt",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 3.3h-2V4c0 1-.8 1.5-1.9 1.5S8.1 5 8.1 4v-.8h-2l-5 5.1 2.2 3.1L5 10v7h10v-7l1.6 1.6 2.3-3.4-5.1-4.9zm2.6 6.9L14 7.7V16H6V7.6l-2.5 2.5-1-1.6 4.1-4.3h.3c.2 1.4 1.5 2.5 3 2.5s2.8-1.1 3-2.5h.3l4.5 4-1.3 2z"
  })));
};
export default SvgTshirt;